<template>
  <el-dialog
    title="新建公司"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal="false"
    width="400px"
  >
    <div class="display-flex mb10">
      <span style="word-break:keep-all">公司全称：</span>
      <el-autocomplete
        v-model="company.公司名称"
        class="autocomplete-input"
        :fetch-suggestions="querySearch"
        placeholder="公司名称"
        :trigger-on-focus="false"
        style="width: 100%;"
        size="mini"
        @select="handleSelect"
      ></el-autocomplete>
    </div>
    <div class="display-flex mb10">
      <span style="word-break:keep-all;display: flex;"><span style="white-space: nowrap;color: #ff0f00;">*</span>简称：</span>
      <el-input v-model="company.简称" placeholder="简称" size="mini" />
    </div>
    <div class="display-flex mb10">
      <span style="word-break:keep-all">行业：</span>
      <el-select v-model="company.行业"
                  class="edit-input"
                  size="mini"
                  filterable>
        <el-option v-for="item in industry" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">取 消</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirm">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      company: {},
      industry: [],
    }
  },
  methods: {
    async open() {
      this.dialogVisible = true
      this.company = { 公司名称: '', 简称: '', 行业: '' }
      this.industry = app.industries || []
    },
    async querySearch(queryString, cb) {
      // 律所不属于工商查询范畴
      if (queryString.match(RegExp(/律/))) return cb([])
      const result = await app.service('company').fuzzySearch({ name: queryString })
      const restaurants = result.status == '200' ? result.data.map(val => ({ value: val.Name })) : []
      // 调用 callback 返回建议列表的数据
      cb(restaurants)
    },
    async handleSelect(val) {
      // this.selectCompanyName = true
      // this.company.公司名称 = val.value
      // this.checkedName.公司名称 = true
      // // 查询公司已存在，可点击跳转
      // const result = await app.service('company').duplicate({ 公司名称: this.company.公司名称 })
      // this.hasName.公司名称 = result == '重复'
      // this.inputerror.公司名称 = result == '重复'
      // if (result == '重复') {
      //   this.$message.warning('该公司已在数据库中存在')
      //   this.hassetcompany = this.company.公司名称
      // }
    },
    async confirm() {
      if (!this.company.简称) return this.$message.error('请填写简称')
      const res = await app.service('company').simpleCreateCompany(this.company)
      if (res.status === 'success') {
        this.$emit('confirm', this.company.简称)
        this.$message.success('创建成功')
        this.dialogVisible = false
      } else this.$message.error(res.msg)
    },
  },
}
</script>
<style scoped>
.display-flex {
  display: flex;
}
</style>
